import { faCircleRight } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";
import { Container } from "reactstrap";
import HeroBg from "src/assets/images/unit-5-hero-bg.jpg";
import Button from "src/components/Button";
import Typography from "src/components/Typography";
import classes from "./styles.module.scss";

const HeroComponent = () => {
  const navigate = useNavigate();

  return (
    <div
      className={classes.wrapper}
      style={{
        backgroundImage: ` url(${HeroBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center 20%", // Focus on specific area
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container className={classes.container}>
        <div className={classes.leftContent} style={{ maxWidth: "580px" }}>
          <Typography className={classes.heading} fontWeight="bold">
            Independent Impact Testing
          </Typography>
          <Typography className={classes.description} variant="p20">
            Configure your Unit 5 Industries impact test parameters and receive
            a comprehensive report detailing the product type, manufacturer,
            warranty status, and any documented changes in condition resulting
            from the test. All testing is independently performed using a
            standardized process that accurately simulates real-world impact
            scenarios with validated precision and consistency.
          </Typography>
          <div className={classes.reportButtons}>
            <Button
              onClick={() => navigate("/order/create")}
              buttonColor="warning"
              buttonClassName={classes.customHomeButton}
              buttonText="Order an Impact Test and Report"
              rightIcon={<FontAwesomeIcon icon={faCircleRight} />}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default HeroComponent;
